export default {
    key: 'mac',
    label: 'MAC',
    surname: [
        // Predators & Hunters
        'Apex',
        'Stalker',
        'Predator',
        'Hunter',
        'Reaper',
        'Raptor',
        'Viper',
        'Jackal',
        'Lynx',
        'Wolverine',
        'Warhound',
        'Hellhound',

        // Mythological & Ancient
        'Titan',
        'Goliath',
        'Colossus',
        'Leviathan',
        'Behemoth',
        'Juggernaut',
        'Cyclops',
        'Nemesis',
        'Hydra',
        'Basilisk',
        'Chimera',
        'Cerberus',
        'Fenrir',
        'Mjolnir',
        'Valkyrie',
        'Ragnarok',

        // Natural Forces
        'Tempest',
        'Cyclone',
        'Maelstrom',
        'Avalanche',
        'Thunderstrike',
        'Blizzard',
        'Firestorm',
        'Inferno',
        'Quake',
        'Tsunami',

        // Military & Tactical
        'Ironclad',
        'Bulwark',
        'Vanguard',
        'Rampart',
        'Citadel',
        'Sentinel',
        'Warden',
        'Paladin',
        'Crusader',
        'Marauder',
        'Ravager',
        'Decimator',
        'Annihilator',
        'Obliterator',
        'Devastator',
        'Vindicator',
        'Retaliator',
        'Liberator',
        'Enforcer',
        'Subjugator',

        // Space & Cosmic
        'Nova',
        'Pulsar',
        'Quasar',
        'Nebula',
        'Void',
        'Eclipse',
        'Solaris',
        'Helios',
        'Oblivion',
        'Singularity',
        'Eventide',
        'Darkstar',
        'Ironstar',

        // Materials & Elements
        'Ironsides',
        'Steelheart',
        'Titanfall',
        'Obsidian',
        'Adamant',
        'Tungsten',
        'Cobalt',
        'Magnesium',

        // Sharp & Cutting
        'Razor',
        'Talon',
        'Fang',
        'Saber',
        'Scythe',
        'Cleaver',
        'Cutlass',
        'Javelin',
        'Halberd',
        'Lancer',

        // Speed & Motion
        'Blitz',
        'Surge',
        'Havoc',
        'Rampage',
        'Onslaught',
        'Juggernaut',
        'Interceptor',
        'Strider',
        'Galloper',

        // Shadows & Darkness
        'Shadow',
        'Specter',
        'Phantom',
        'Wraith',
        'Banshee',
        'Revenant',
        'Ghost',
        'Nightstalker',
        'Dusk',
        'Umbra',
    ]
};
